import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";

import type { CertificateActions } from "../../../shared/api-types/certificate";
import BundleList from "../../../components/BundleList";
import Spinner from "../../../components/Spinner";
import { getAvailableProducts, Bundle } from "../../../api/payment";

export type BundleWithActions = Bundle & {
  actions: CertificateActions;
};

interface BundlesProps {
  crewId: number;
  userId: number;
  boughtProducts: {
    bundles?: number[];
    courses?: number[];
  } | null;
}

const Bundles: FC<BundlesProps> = ({ crewId, userId, boughtProducts }) => {
  const { t } = useTranslation();
  const [bundles, setBundles] = useState<any[] | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const available = await getAvailableProducts(crewId, userId);
        const boughtBundleIds = boughtProducts?.bundles || [];

        // Enrich bundles with actions for the Actions component
        const enrichedBundles =
          available?.bundles?.map((bundle) => {
            const isBought = boughtBundleIds.includes(bundle.id);
            return {
              ...bundle,
              actions: {
                canUploadCertificate: false,
                isReupload: false,
                playableCourse: null,
                purchasableCourse: isBought ? null : bundle,
                downloadableCertificate: null,
                noNewCourseAvailable: false,
                isPendingApproval: false,
                hasHistory: false,
                isPurchased: isBought,
              },
            };
          }) || [];
        setBundles(enrichedBundles);
      } catch (error) {
        console.error("Error fetching bundles:", error);
        setBundles([]);
      }
    })();
  }, [crewId, userId, boughtProducts]);

  if (bundles === null) {
    return <Spinner message={t("compliance.loading_bundles")} />;
  }

  if (bundles.length === 0) {
    return <Typography>{t("compliance.no_bundles_available")}</Typography>;
  }

  return <BundleList bundles={bundles} />;
};

export default Bundles;
